export const TokenViewer = ({ title, value, data_qa }: any) => {
  return !value ? (
    <></>
  ) : (
    <div data-qa={data_qa}>
      <div>
        <h3>{title}</h3>
        <pre>{JSON.stringify(value, null, 2)}</pre>
      </div>
    </div>
  );
};
